module.exports = __webpack_public_path__ + "img/toronto.61eeb77a.jpg";